import { z } from 'zod';

import type { AgentBrokerInput } from '@/lib/api/domains/agents-brokers';

/*
 * Agent/broker form schema. Mirrors the provider/invoice/client form pattern: a
 * Zod schema for the fields the user edits, plus a `toAgentBrokerInput`
 * transform to the API input shape. Optional text fields normalize empty
 * strings to `undefined` so we never send a blank DBA/type/NPN to the BFF.
 */
export const agentBrokerFormSchema = z.object({
  name: z.string().min(1, 'Name is required.'),
  dbaName: z.string().optional(),
  agentType: z.string().optional(),
  npn: z.string().optional(),
  status: z.enum(['active', 'inactive']),
});

export type AgentBrokerFormValues = z.infer<typeof agentBrokerFormSchema>;

/** Convert form values to the API input shape (drops blank optionals). */
export function toAgentBrokerInput(
  values: AgentBrokerFormValues,
): AgentBrokerInput {
  return {
    name: values.name,
    status: values.status,
    ...(values.dbaName?.trim() ? { dbaName: values.dbaName.trim() } : {}),
    ...(values.agentType?.trim() ? { agentType: values.agentType.trim() } : {}),
    ...(values.npn?.trim() ? { npn: values.npn.trim() } : {}),
  };
}
